import { Box, Typography, InputAdornment, Link, useMediaQuery, useTheme } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "@mui/lab";

import { imageSource, Strings } from "@app/constants";
import { FormProvider, RHFTextField } from "@app/components";
import { PATH_AUTH } from "@app/routes/paths";
import { AuthLayout } from "@app/layouts";
import { useRequestState } from "@app/hooks";

import { login } from "../slice";
import { selectLoginState } from "../selectors";
import { loginSchema } from "../validators";

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));
  const methods = useForm<any>({
    resolver: yupResolver(loginSchema),
    defaultValues: {
      email: "",
      password: "",
    },
  });
  const onSubmit = (form: any) => {
    dispatch(login(form));
  };
  const { loading } = useRequestState({
    stateSelector: selectLoginState,
    errorShown: true,
    successMessageShown: true,
  });
  return (
    <>
      <AuthLayout title={Strings.auth.logIn}>
        <Box
          sx={{
            overflowY: "auto",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          <Typography
            fontFamily={"Work Sans"}
            fontWeight={700}
            color="#2D2D2D"
            mb={4}
            fontSize={24}
            textAlign={isLargeScreen?'left':'center'}
          >
            {Strings.auth.logIn}
          </Typography>
          <FormProvider
            methods={methods}
            onSubmit={methods.handleSubmit(onSubmit, () => {
              window.scrollTo(0, 0);
            })}
          >
            <Typography fontFamily={"Work Sans"} fontWeight={500} color="#111214">
              Email Address
            </Typography>
            <RHFTextField
              name="email"
              fullWidth
              placeholder="Email-Address"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img
                      alt="emailIcon"
                      src={imageSource.emailIcon}
                      style={{ width: 25, height: 25, objectFit: "contain" }}
                    />
                  </InputAdornment>
                ),
              }}
              sx={{
                mb: 3,
                mt: 1,
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#f4f6f8",
                  borderRadius: "12px",
                  "& fieldset": {
                    border: "none",
                  },
                },
              }}
            />
            <Typography fontFamily={"Work Sans"} fontWeight={500} color="#111214">
              Password
            </Typography>
            <RHFTextField
              name="password"
              fullWidth
              type="password"
              placeholder="password"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img
                      alt="passwordIcon"
                      src={imageSource.passwordIcon}
                      style={{ width: 25, height: 25, objectFit: "contain" }}
                    />
                  </InputAdornment>
                ),
              }}
              sx={{
                mb: 3,
                mt: 1,
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#f4f6f8",
                  borderRadius: "12px",
                  "& fieldset": {
                    border: "none",
                  },
                },
              }}
            />

            <Box sx={{ textAlign: "right", mb: 3 }}>
              <Link
                underline="none"
                fontFamily={"Work Sans"}
                fontWeight={500}
                sx={{
                  fontSize: 14,
                  color: "#484848",
                  cursor: "pointer",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
                onClick={() => navigate(PATH_AUTH.forgotPassword)}
              >
                {Strings.auth.forgotPassword}
              </Link>
            </Box>

            <Box display="flex" justifyContent="center" mt={4}>
              <LoadingButton
                type="submit"
                variant="contained"
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  color: "#fff",
                  py: 1.5,
                  fontFamily: "Work Sans",
                  fontWeight: 500,
                  width: "100%",
                  maxWidth: "400px",
                }}
                loading={loading}
              >
                {Strings.auth.logIn}
              </LoadingButton>
            </Box>
          </FormProvider>
          {/* <Typography
            fontFamily={"Work Sans"}
            fontWeight={500}
            textAlign={"center"}
            sx={{ marginTop: 5, color: "#484848" }}
          >
            {Strings.auth.doNotHave}
            <Link
              href="#"
              underline="none"
              fontFamily={"Work Sans"}
              fontWeight={500}
              sx={{
                color: theme.palette.primary.main,
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
              onClick={() => navigate(PATH_AUTH.signUp)}
            >
              {Strings.auth.signUp}
            </Link>
          </Typography> */}
        </Box>
      </AuthLayout>
    </>
  );
};

export { LoginPage };
